import React from "react";
import Heading from "../../components/common/Typography/Heading";
import MainButton from "../../components/common/MainButton/MainButton";
import { useNavigate } from "react-router-dom";
import {
  PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const HelpSupport = ({
  sectionClassName = PUBLIC_SECTION_GAP_CLASS,
  imageToContentClassName = PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div className={`tp-container-small mx-auto ${sectionClassName} relative`}>
        <div className="flex items-center justify-between">
          <Heading variant={"h2"} className={"text-offblack"}>
            Can we help?
          </Heading>
          <MainButton
            variant={"medium"}
            type="button"
            onClick={() => navigate("/HelpCentre")}
          >
            Help Centre
          </MainButton>
        </div>
        <div
          className={`w-full h-[400px] 2xl:h-[450px] sm:aspect-[1075/450] ${imageToContentClassName}`}
        >
          <img
            src={require("../../assets/img/handshaking.jpg")}
            className="w-full h-full rounded-xl object-cover"
            alt=""
          />
        </div>
      </div>
    </>
  );
};

export default HelpSupport;
